<template>
  <v-container fluid>
    <!-- Products List -->
    <v-data-iterator
      :items="filteredProducts"
      :items-per-page="itemsPerPage"
      v-model:search="search"
      :loading="loading"
    >
      <template v-slot:header="{ page, pageCount, prevPage, nextPage }">
        <v-row class="mb-4" align="center" justify="center">
          <v-col>
            <v-text-field
      v-model="search"
      variant="solo"
      rounded="xl"
      prepend-inner-icon="mdi-magnify"
      placeholder="Cari produk kebutuhan Anda..."
      hide-details
      clearable
      class="search-box"
      style="max-width: 800px"
    ></v-text-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="{ items }">
  <v-row v-if="items.length === 0" class="justify-center">
    <v-col cols="12" class="text-center">
      <v-alert type="info" border="left" icon="mdi-information">No Products Available</v-alert>
    </v-col>
  </v-row>

  <v-row v-else class="mb-2 product-row">
    <v-col
      v-for="({ raw }, i) in items"
      :key="raw.product_id || i"
      cols="6" sm="4" md="3" lg="3"
    >
      <v-card
        class="product-card"
        :elevation="2"
        rounded="xl"
      >
        <!-- Media -->
        <div class="media-wrap">
          <v-img
            :src="getImageUrl(getFirstImage(raw.medias))"
            :lazy-src="getImageUrl(getFirstImage(raw.medias))"
            :alt="raw.product_name"
            class="media-img"
            cover
          >
            <template #placeholder>
              <v-skeleton-loader type="image" class="h-100 w-100"></v-skeleton-loader>
            </template>
          </v-img>
        </div>

        <!-- Body -->
        <v-card-item class="pa-3">
          <div class="product-title text-subtitle font-weight-bold">
            {{ raw.product_name }}
          </div>
          <div class="product-price text-primary text-subtitle font-weight-medium mt-1">
            {{ raw.price_display }}
          </div>
        </v-card-item>

        <v-divider class="mx-4 mb-1"></v-divider>

        <!-- Action Button -->
        <v-card-actions>
          <v-btn
            rounded="xl"
            variant="elevated"
            block
            color="primary"
            @click="viewDetails(raw.product_id)"
          >
            Lihat detail
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>


      <template v-slot:footer="{ page, pageCount, prevPage, nextPage }">
  <div class="iterator-footer">
    <v-btn
      :disabled="page === 1"
      icon="mdi-arrow-left"
      size="small"
      variant="tonal"
      @click="prevPage"
    />
    <div class="page-indicator">{{ page }} / {{ pageCount }}</div>
    <v-btn
      :disabled="page === pageCount"
      icon="mdi-arrow-right"
      size="small"
      variant="tonal"
      @click="nextPage"
    />
  </div>
</template>


      <template v-slot:loader>
        <v-row>
          <v-col
            v-for="(_, k) in [0, 1, 2, 3]"
            :key="k"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-skeleton-loader
              class="border"
              type="image, article"
              :loading="loading"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import numeral from 'numeral'
export default {
  data() {
    return {
      products: [], // All products from server
      filteredProducts: [], // Filtered products for display
      itemsPerPage: 10,
      search: '',
      loading: false,
      page: 1,
      pageCount: 0,
      categories: [], // Make sure this is populated with category data
      subcategories: [], // Make sure this is populated with subcategory data
      bendaRohaniCategoryId: null, // ID for "Benda Rohani" category
      expandedIndex: null,
      
      activeSubId: null,
      activeSubSlug: null,
    };
  },
  watch: {
  '$route.query.sid': {
    immediate: true,
    handler() {
      this.activeSubId = this.$route.query.sid || null;
      this.filterProducts(); // panggil filter client-side
    }
  },
  '$route.query.sub': {
    immediate: true,
    handler() {
      this.activeSubSlug = this.$route.query.sub || null;
      this.filterProducts(); // panggil filter client-side
    }
  },
},
  methods: {
    slugify(s) {
  return (s || '')
    .toString().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9\s-]/g, '')
    .trim().replace(/\s+/g, '-');
},

// [ADD] — filter client-side berdasarkan sid/sub terhadap this.products
filterProducts() {
  // jika belum ada data produk, langsung sync filteredProducts
  if (!Array.isArray(this.products) || this.products.length === 0) {
    this.filteredProducts = [];
    return;
  }

  // Prioritas: sid (ID) > sub (slug). Tanpa keduanya = semua item
  if (this.activeSubId) {
    this.filteredProducts = this.products.filter(
      p => String(p?.subcategory?.subcategory_id) === String(this.activeSubId)
    );
  } else if (this.activeSubSlug) {
    this.filteredProducts = this.products.filter(
      p => this.slugify(p?.subcategory?.subcategory) === this.activeSubSlug
    );
  } else {
    this.filteredProducts = this.products.slice();
  }
},
    toggleExpand(index) {
      this.expandedIndex = this.expandedIndex == index ? null : index; // Toggle expansion for each card
    },
    getFirstImage(medias) {
    if (medias && medias.length > 0) {
      // Sort the images by display_order and return the first one
      const firstImage = medias.sort((a, b) => a.display_order - b.display_order)[0];
      return firstImage?.media?.media_name;
    }
    return ''; // Return an empty string if no image is available
  },
    async fetchProducts() {
      try {
        this.loading = true;
        const response = await this.$axios.get('/grosir', {
          params: {
            page: this.page,
            per_page: this.itemsPerPage
          }
        });
        this.products = response.data.data;
        this.filteredProducts = this.products; // Initialize filteredProducts with all products
        this.pageCount = response.data.meta
          ? response.data.meta.total_pages
          : 0;
        this.loading = false;
        this.filterProducts(); // Apply filtering
      } catch (error) {
        this.showSnackbar(
          'Error fetching products: ' +
          (error.response?.data?.message || 'Something went wrong'),
          'error'
        );
        this.loading = false;
      }
    },
    async fetchCategories() {
      try {
        const response = await this.$axios.get("/category");
        this.categories = response.data.data; // Access nested data
        
        // Set the "Benda Rohani" category ID
        const bendaRohaniCategory = this.categories.find(
          (cat) => cat.category == 'Grosir'
        );
        this.bendaRohaniCategoryId = bendaRohaniCategory ? bendaRohaniCategory.category_id : null;
      } catch (error) {
        this.showSnackbar(
          "Error fetching categories: " +
          (error.response?.data?.message || "Something went wrong"),
          "error"
        );
      }
    },
    async fetchSubcategories() {
      try {
        const response = await this.$axios.get("/subcategory");
        this.subcategories = response.data.data;
      } catch (error) {
        this.showSnackbar("Error fetching subcategories.", "error");
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page -= 1;
        this.fetchProducts();
      }
    },
    nextPage() {
      if (this.page < this.pageCount) {
        this.page += 1;
        this.fetchProducts();
      }
    },
    getImageUrl(imageName) {
      return `${this.$urlImage}storage/images/${imageName}`;
    },
    showSnackbar(message, color = 'success') {
      this.$emit('show-snackbar', { message, color });
    },
    viewDetails(productId) {
      // Navigate to product details view
      this.$router.push({ name: 'product-detail', params: { id: productId } });
    },
    numeralFormat(value, format) {
      return numeral(value).format(format) // Modify to use any numeral format as required
    },
  },
  mounted() {
    this.fetchProducts();
    this.fetchCategories();
    this.fetchSubcategories();
  },
};
</script>

<style scoped>
.iterator-footer {
  position: sticky;     /* nempel di bawah area iterator saat scroll */
  bottom: 0;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  background: rgb(var(--v-theme-background));     /* kontras di atas konten */
  border-top: 1px solid rgba(0,0,0,0.06);
  z-index: 1;
}

.page-indicator {
  font-weight: 600;
  min-width: 64px;
  text-align: center;
}

.product-card {
  transition: transform .18s ease, box-shadow .18s ease;
  background: rgb(var(--v-theme-surface));
}
@media (hover:hover) {
  .product-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0,0,0,0.08);
  }
  .media-img {
    transition: transform 0.25s ease;
  }
  .product-card:hover .media-img {
    transform: scale(1.05);
  }
}

.media-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1; 
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}
.media-img {
  width: 100%;
  height: 100%;
}


@media (max-width: 600px) {
  .product-row {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
